import axiosInstance from "../axios/axiosInstance";
import { encrypt } from "../scenes/global/helperFunctions";

const getEncryptedClubId = () => encrypt(localStorage.getItem("club_id"));

export const fetchTemplatesList = () => {
  const params = {
    clubId: getEncryptedClubId(),
  };
  return axiosInstance.get("/api/form-templates/dropdown", { params });
};

export const createFormTemplate = (data) => {
  return axiosInstance.post("/api/form-templates", data);
};

export const fetchFormTemplate = (formTemplateMasterId = null) => {
  const params = {
    clubId: getEncryptedClubId(),
  };
  if (formTemplateMasterId !== null && formTemplateMasterId !== undefined) {
    params.formTemplateMasterId = encrypt(String(formTemplateMasterId));
  }
  return axiosInstance.get("/api/form-templates", { params });
};

export const fetchCrewTemplatesList = () => {
  const params = {
    clubId: getEncryptedClubId(),
  };
  return axiosInstance.get("/api/crew-templates/dropdown", { params });
};

export const fetchCrewTemplatesDeatil = (crewId) => {
  const params = {
    crewTemplateMasterId: crewId,
  };
  return axiosInstance.get("/api/crew-templates/details", { params });
};


export const fetchEntryFee = () => {
  const params = {
    clubId: getEncryptedClubId(),
  };
  return axiosInstance.get("/api/fee-setup", { params });
};